<template>
  <el-menu class="navbar" mode="horizontal">
    <div class="card" style="background-color: #FFFFFF;width: 100%;height: 62px;padding-left: 8px;padding-right: 8px">
      <hamburger class="hamburger-container" :toggleClick="toggleSideBar" :isActive="sidebar.opened"></hamburger>
      <breadcrumb></breadcrumb>
      <el-dropdown class="avatar-container" trigger="click">
        <div class="avatar-wrapper">
          <img class="user-avatar" :src="avatar">
          <i class="el-icon-caret-bottom"></i>
        </div>
        <el-dropdown-menu class="user-dropdown" slot="dropdown">
          <router-link class="inlineBlock" to="/">
            <el-dropdown-item>
              首页
            </el-dropdown-item>
          </router-link>
          <el-dropdown-item divided>
            <span @click="logout" style="display:block;">退出</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </el-menu>
</template>

<script>
import { mapGetters } from 'vuex'
import Breadcrumb from '@/components/Breadcrumb'
import Hamburger from '@/components/Hamburger'

export default {
  components: {
    Breadcrumb,
    Hamburger
  },
  computed: {
    ...mapGetters([
      'sidebar',
      'avatar'
    ])
  },
  methods: {
    toggleSideBar() {
      this.$store.dispatch('ToggleSideBar')
    },
    logout() {
      this.$store.dispatch('LogOut').then(() => {
        location.reload() // 为了重新实例化vue-router对象 避免bug
      })
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>

.card {
  background-clip:padding-box;
  box-shadow:0 2px 6px 0 rgba(67, 89, 113, 0.12);
  border-radius: 0.3rem;
}

.navbar {
  height: 62px;
  line-height: 62px;
  border-radius: 0px !important;
  padding: 12px 16px 0px 16px;
  background-color: #f2f2f2;
  border-bottom:solid 0px #e6e6e6;

  .hamburger-container {
    line-height: 62px;
    height: 62px;
    float: left;
    padding-left: 12px;
    padding-right: 12px;
    background-color: #ffffff;
  }
  .screenfull {
    position: absolute;
    right: 90px;
    top: 16px;
    color: red;
  }
  .avatar-container {
    height: 62px;
    display: inline-block;
    position: absolute;
    right: 45px;
    .avatar-wrapper {
      cursor: pointer;
      margin-top: 0px;
      position: relative;
      .user-avatar {
        margin-top: 10px;
        width: 42px;
        height: 42px;
        border-radius: 10px;
      }
      .el-icon-caret-bottom {
        position: absolute;
        right:-15px;
        top: 25px;
        font-size: 12px;
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/views/layout/components/Navbar.vue